import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface, Empty_Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { Empty_LetterRequestCustomer_Device_Interface, LetterRequestCustomer_Device_Interface } from 'src/app/Interface/LetterRequestCustomer_Device_Interface';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { MailMessageService } from 'src/app/Service/MailMessage/MailMessage.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-CalibrationReceptionForm',
  templateUrl: './CalibrationReceptionForm.component.html',
  styleUrls: ['./CalibrationReceptionForm.component.css']
})
export class CalibrationReceptionFormComponent implements OnInit {


  @Input() Calibration_Form_Id
  @Output() OnBack_Calibration_Action = new EventEmitter<number>();

  Token:String=""
  page:number=0;
  Calibration_Form_Code:string=''
  Calibration_Form_Dsc:string=''
  Calibration_Form_TahvilDahandeh:string=''
  BaseUrl:String=environment.BaseUrl+"Fish/Print?id="
  BaseUrl2:String=environment.BaseUrl+"Fish/Print2?id="

  PrintURl:String=environment.Print_URL+"QRCodeFish1/"
  PrintURl2:String=environment.Print_URL+"QRCodeFish1_2/"

  Filter_CustomerName:string=''
  Filter_LetterCode: string = ''

  visible_karshnas:boolean=false

  constructor(
    private Customer_Service:CustomerService,
    private modalService: BsModalService,
    private Alerify:AlertifyService,
    private Device_Service:DeviceService,
    private Nav_Service:NavService,
    private Calibration_Service:CalibrationService,
    private Expiration_Service:ExpirationService,
    private DeviceBehfa_Service:DeviceBehfaService,
    private MailMessage_Service:MailMessageService,
    private LetterRequestCustomer_Service:LetterRequestCustomerService,
  ) { }

  ngOnInit() {

    localStorage.removeItem('Daro_User_Comment')

    this.Token=localStorage.getItem('Daro_User_Token');

    this.BaseUrl=environment.BaseUrl + "Fish/Print?token="+ this.Token+"&id="
    this.BaseUrl2=environment.BaseUrl + "Fish/Print2?token="+ this.Token+"&id="


    this.RabetMasolCustomer=new FormGroup({
      id :new FormControl(),
      FName:new FormControl(null,Validators.required),
      LName:new FormControl(null,Validators.required),
      Sex:new FormControl("1",Validators.required),
      Semat:new FormControl(null,Validators.required),
      Mobile:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      majaziMobile:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      jaygozinMiblie:new FormControl('',Validators.pattern('^[0-9]{10}$')),
      Tel:new FormControl(''),
      Dsc:new FormControl(null),
      Type:new FormControl('0'),
    })

    this.EdCustomer=new FormGroup({
      type:new FormControl(null),
      ModirAmelName:new FormControl(null),
      ModirAmelMobile:new FormControl(null),
      ModirAmelTel:new FormControl(null),
      ModirAmelDakheli:new FormControl(null),
      ModirAmelEmail:new FormControl(null,Validators.email),
    })

    this.MailMessageForm = new FormGroup({
      mailmessage_id: new FormControl("0", Validators.required),
    })

    this.Nav_Service.CheckValidPage(this.Token,4).subscribe(
      data=>{
        if(this.Calibration_Form_Id)
        {
          this.OnInitail_Form(this.Calibration_Form_Id);
        }
        else{
          this.Calibration_Form_Id="0"
          this.ReadData_LetterRequestCustomer()
        }

        this.Read_Expiration()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  OnInitail_Form(id){
    this.Calibration_Service.GetSingle(this.Token,id,0,0).subscribe(
      data=>{
        this.Selected_LetterRequestCustomer_Device_Interface=data['letterRequestCustomer_Device_Detail']
        this.FormAdded_MailMessage=data['mail']
        this.Data_List_Calibration=data['device']
        var temp: Calibration_List_Interface = data['model']

        this.visible_karshnas = temp.visible_karshnas

        this.Calibration_Form_Code=temp.code

        this.Selected_DataList_LetterRequestCustomer.id=data['model']['letterRequestCustomer_Id']
        this.Calibration_Form_Dsc=data['model']['dsc']
        this.Calibration_Form_TahvilDahandeh=data['model']['tavilDahandeh']
        this.Data_Seleted_ReciveCustomer_Dsc=data['model']['reciver_Customer_Dsc']

        if(temp.status=="1")
        {
          this.OnSubmitForm_Finish=true
        }

        this.Data_Seleted_Customer.id=temp.customerId
        this.Data_Seleted_Customer.code=temp.customerCode
        this.Data_Seleted_Customer.name=temp.customerName
        this.Data_Seleted_Customer.type=temp.customerType

        this.Data_Seleted_ReciveCustomer=data['reciveUser']






        this.ReadData_Initial_Customer()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



  //#region Customer
  ProcssingCustomer:boolean=false
  modalRef_Customer: any;

  Edit_Customer_Record:Customer_Interface=Empty_Customer_Interface()

  Search_CodeName_Customer_Table:string=''
  Search_Type_Customer_Table:string='2'

  DataList_Customer:Array<Customer_List_Interface>=[]
  Data_Seleted_Customer_Type:number=0
  Data_Seleted_Customer:Customer_List_Interface=Empty_Customer_List_Interface()
  Data_Seleted_ReciveCustomer:Customer_List_Interface=Empty_Customer_List_Interface()
  Data_Seleted_ReciveCustomer_Dsc:string=''

  ReadData_Customer_KeySearch_Timer:any
  ReadData_Customer_KeySearch(){

    if (this.ReadData_Customer_KeySearch_Timer) {
      clearTimeout(this.ReadData_Customer_KeySearch_Timer);
      this.ReadData_Customer_KeySearch_Timer = null;
  }

  this.ReadData_Customer_KeySearch_Timer = setTimeout(function (){
    this.ReadData_Customer()
  }.bind(this), 1000);

  }

  ReadData_Customer(){

    if(!this.Search_CodeName_Customer_Table)
    {
      this.DataList_Customer=[]
    }
    else{


      this.ProcssingCustomer=true
        this.Customer_Service.GetSearchCalibration(this.Token,this.Search_CodeName_Customer_Table).subscribe(
          data=>{
            this.DataList_Customer=data
            this.ProcssingCustomer=false
          },error=>{
            localStorage.clear()
            location.reload();

          }
        )
    }
  }


  openModal_Customer(template: TemplateRef<any>,type_Customer) {
    this.Data_Seleted_Customer_Type=type_Customer
    this.modalRef_Customer = this.modalService.show(template);
  }

  Set_Selected_Customer_Record(item){
    if(this.Data_Seleted_Customer_Type==0)
    {
      this.Selected_DataList_LetterRequestCustomer=Empty_LetterRequestCustomer_List_Interface()
      this.Data_Seleted_Customer=item
      this.ReadData_Initial_Customer()
    }
    else{
      this.Data_Seleted_ReciveCustomer=item
    }
    this.modalRef_Customer.hide()
  }

  Read_Recipt_Letter_Info(){
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerCalibrationRecipt(this.Token,this.Selected_DataList_LetterRequestCustomer.id,false).subscribe(
      data=>{
        this.Calibration_Form_Id = Number(data['calibration_Id'])
        this.Calibration_Form_Code=data['calibration_Code']
        if(this.Calibration_Form_Id>0)
        {
          this.OnInitail_Form(this.Calibration_Form_Id);
        }
        else{
          this.ReadData_Initial_Customer()
        }
      }
    )
  }

  ReadData_Initial_Customer(){
    this.Customer_Service.GetSingle(this.Token,this.Data_Seleted_Customer.id).subscribe(
      data=>{

        this.DataList_KarshnasMasol=data['karshnasMasol']

        localStorage.setItem('Daro_User_Comment', JSON.stringify(this.Data_Seleted_Customer));


        for(let item of this.DataList_KarshnasMasol)
        {
          item.Tel=[]

            for (let itemDetail of item.tel_temp.split(','))
            {
              if(itemDetail!="-1")
              {
                  item.Tel.push({
                    id:0,
                    title:itemDetail,
                    code:'',
                    dsc:'',
                    del:false,
                    DeletingProccess:false
                  })
              }

            }
          item.tel_temp='-1'
        }

        this.Edit_Customer_Record=data['model']
        this.get_Form_ModirAmelMobile().setValue(this.Edit_Customer_Record.modirAmelMobile)
        this.get_Form_ModirAmelTel().setValue(this.Edit_Customer_Record.modirAmelTel)
        this.get_Form_ModirAmelDakheli().setValue(this.Edit_Customer_Record.modirAmelDakheli)
        this.get_Form_ModirAmelEmail().setValue(this.Edit_Customer_Record.modirAmelEmail)

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Proccesing_OnSubmitForm_Csutomer:boolean=false
  OnSubmitFormCustomer(){



    var Karshnas_Masol_Mobile:number=-1
    var Karshnas_Masol_Email:number=-1
    for(let item of this.DataList_KarshnasMasol)
    {
      if(!item.mobile && !this.Edit_Customer_Record.foreign)
      {
        Karshnas_Masol_Mobile=this.DataList_KarshnasMasol.indexOf(item)
        break
      }

      if(item.Email.length == 0 && this.Edit_Customer_Record.foreign)
      {
        Karshnas_Masol_Email=this.DataList_KarshnasMasol.indexOf(item)
        break
      }
    }


    if(Karshnas_Masol_Mobile>-1){
      this.Alerify.ErrorMessage("Enter the calibration technician mobile number in row "+(Karshnas_Masol_Mobile+1)+".")
    }
    else if(Karshnas_Masol_Email>-1){
      this.Alerify.ErrorMessage("Enter the calibration technician email in row "+(Karshnas_Masol_Email+1)+".")
    }
    else{
    this.Proccesing_OnSubmitForm_Csutomer=true
      var CustomerRecord:Customer_Interface=Empty_Customer_Interface()
      CustomerRecord.id=this.Edit_Customer_Record.id

      CustomerRecord.modirAmelMobile=this.get_Form_ModirAmelMobile().value
      CustomerRecord.modirAmelTel=this.get_Form_ModirAmelTel().value
      CustomerRecord.modirAmelDakheli=this.get_Form_ModirAmelDakheli().value
      CustomerRecord.modirAmelEmail=this.get_Form_ModirAmelEmail().value

      this.Customer_Service.EditCalibration(
        CustomerRecord,
        this.DataList_KarshnasMasol,
        this.Token).subscribe(
        data=>{
          this.Proccesing_OnSubmitForm_Csutomer=false
          this.Alerify.SuccessMessage("Information saved successfully.")

        },error=>{
          localStorage.clear()
          location.reload();

        }
      )

    }

  }

  //#endregion


  //#region Customer edit form

    EdCustomer:FormGroup;

    get_Form_ModirAmelMobile(){
      return this.EdCustomer.get('ModirAmelMobile') as FormControl;
    }

    get_Form_ModirAmelTel(){
      return this.EdCustomer.get('ModirAmelTel') as FormControl;
    }

    get_Form_ModirAmelDakheli(){
      return this.EdCustomer.get('ModirAmelDakheli') as FormControl;
    }

    get_Form_ModirAmelEmail(){
      return this.EdCustomer.get('ModirAmelEmail') as FormControl;
    }

    //#endregion



  //#region Responsible contact form

  RabetMasolCustomer:FormGroup;

  get_Form_RabetMasol_FName(){
    return this.RabetMasolCustomer.get('FName') as FormControl;
  }

  get_Form_RabetMasol_LName(){
    return this.RabetMasolCustomer.get('LName') as FormControl;
  }

  get_Form_RabetMasol_Sex(){
    return this.RabetMasolCustomer.get('Sex') as FormControl;
  }

  get_Form_RabetMasol_Semat(){
    return this.RabetMasolCustomer.get('Semat') as FormControl;
  }

  get_Form_RabetMasol_Mobile(){
    return this.RabetMasolCustomer.get('Mobile') as FormControl;
  }

  get_Form_RabetMasol_majaziMobile(){
    return this.RabetMasolCustomer.get('majaziMobile') as FormControl;
  }

  get_Form_RabetMasol_jaygozinMiblie(){
    return this.RabetMasolCustomer.get('jaygozinMiblie') as FormControl;
  }

  get_Form_RabetMasol_Tel(){
    return this.RabetMasolCustomer.get('Tel') as FormControl;
  }

  get_Form_RabetMasol_Id(){
    return this.RabetMasolCustomer.get('id') as FormControl;
  }

  get_Form_RabetMasol_Dsc(){
    return this.RabetMasolCustomer.get('Dsc') as FormControl;
  }

  get_Form_RabetMasol_Type(){
    return this.RabetMasolCustomer.get('Type') as FormControl;
  }

  //#endregion

  //#region Responsible technician

  RabetMasolCustomer_Tel:Array<General_Interface>=[]
  OnAdd_RabetMasolCustomer_Tel(){

    var Exited:boolean=false
    for  (let item of this.RabetMasolCustomer_Tel)
    {
      if(item.title==this.get_Form_RabetMasol_Tel().value)
      {
        Exited=true;
        break
      }
    }


    if(this.RabetMasolCustomer_Tel.length==3)
    {
      this.Alerify.ErrorMessage("No more than 3 phone numbers can be registered.")
    }
    else if(Exited)
    {
      this.Alerify.ErrorMessage("The phone number already exists in the list.")
    }
    else
    {
      var temp:General_Interface=Empty_General_Interface()
      temp.title=this.get_Form_RabetMasol_Tel().value
      this.RabetMasolCustomer_Tel.push(temp)
      this.get_Form_RabetMasol_Tel().setValue("")
      this.Alerify.SuccessMessage("The phone number was added to the list.")
    }
  }
  RabetMasolCustomer_Tel_Delete(id){
    this.RabetMasolCustomer_Tel.splice(id,1)
    this.Alerify.SuccessMessage("The phone number was removed from the list.")
  }

  //#endregion

  //#region Responsible technician table

  DataList_KarshnasMasol:Array<KarshnasMasol_Interface>=[]
  OnSubmit_KarshnasMasolForm(){

    var temp:KarshnasMasol_Interface=Empty_KarshnasMasol_Interface()
    temp.id=0
    temp.fname=this.get_Form_RabetMasol_FName().value
    temp.lname=this.get_Form_RabetMasol_LName().value
    temp.sex=Number(this.get_Form_RabetMasol_Sex().value)
    temp.semat=this.get_Form_RabetMasol_Semat().value
    temp.dsc=this.get_Form_RabetMasol_Dsc().value

    temp.mobile=this.get_Form_RabetMasol_Mobile().value
    temp.jaygozinMiblie=this.get_Form_RabetMasol_jaygozinMiblie().value
    temp.majaziMobile = this.get_Form_RabetMasol_majaziMobile().value
    temp.type=Number(this.get_Form_RabetMasol_Type().value)
    temp.Tel=this.RabetMasolCustomer_Tel


    if (!this.Check_KarshnasMasolForm(temp,this.KarshnasMasolForm_Edit_Id))
    {
      this.Alerify.ErrorMessage("The responsible technician information already exists in the list.")
    }
    else if(this.KarshnasMasolForm_Edit_Id==-1)
    {
      if(this.DataList_KarshnasMasol.length<20)
      {
        this.DataList_KarshnasMasol.push(temp)

        this.RabetMasolCustomer.reset();

        this.get_Form_RabetMasol_Type().setValue("0")


        this.RabetMasolCustomer_Tel=[]

        this.Alerify.SuccessMessage("The responsible technician was added to the list.")
      }
      else{
        this.Alerify.ErrorMessage("No more than 20 responsible technicians can be registered.")
      }
    }

    else{
        //this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].id=this.get_Form_RabetMasol_Id().value
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].fname=temp.fname
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].lname=temp.lname
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].sex=temp.sex
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].semat=temp.semat
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].dsc=temp.dsc
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Email=temp.Email
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].mobile=temp.mobile
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].jaygozinMiblie=temp.jaygozinMiblie
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].majaziMobile=temp.majaziMobile
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Dakhli=temp.Dakhli
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].Tel = temp.Tel
        this.DataList_KarshnasMasol[this.KarshnasMasolForm_Edit_Id].type=temp.type
        this.Alerify.SuccessMessage("The responsible technician was updated.")
        this.KarshnasMasolForm_Edit_Id = -1

        this.RabetMasolCustomer.reset();

        this.get_Form_RabetMasol_Type().setValue("0")


        this.RabetMasolCustomer_Tel=[]
    }



  }

  Check_KarshnasMasolForm(Record:KarshnasMasol_Interface,index:number) {
    for (let item of this.DataList_KarshnasMasol)
    {
      if (this.DataList_KarshnasMasol.indexOf(item) == index)
      {

      }
      else if ((item.lname == Record.lname && item.fname == Record.fname ) || item.mobile == Record.mobile)
      {
        return false
      }
    }
    return true
  }

  KarshnasMasolForm_Delete(id){
    this.DataList_KarshnasMasol.splice(id,1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
  }

  KarshnasMasolForm_Edit_Id:number=-1
  KarshnasMasolForm_Edit(id){
    this.KarshnasMasolForm_Edit_Id=id

    var temp=this.DataList_KarshnasMasol[id]
    this.RabetMasolCustomer_Tel=temp.Tel

    this.get_Form_RabetMasol_Mobile().setValue(temp.mobile)
    this.get_Form_RabetMasol_jaygozinMiblie().setValue(temp.jaygozinMiblie)
    this.get_Form_RabetMasol_majaziMobile().setValue(temp.majaziMobile)

    this.get_Form_RabetMasol_Id().setValue(temp.id)
    this.get_Form_RabetMasol_Semat().setValue(temp.semat)
    this.get_Form_RabetMasol_FName().setValue(temp.fname)
    this.get_Form_RabetMasol_LName().setValue(temp.lname)
    this.get_Form_RabetMasol_Sex().setValue(temp.sex)
    this.get_Form_RabetMasol_Dsc().setValue(temp.dsc)
  }

  KarshnasMasolForm_Edit_Cancel(){
    this.KarshnasMasolForm_Edit_Id=-1
    this.get_Form_RabetMasol_Id().setValue(0)
    this.get_Form_RabetMasol_Semat().setValue("")
    this.get_Form_RabetMasol_Dsc().setValue("")

    this.get_Form_RabetMasol_Mobile().setValue("")
    this.get_Form_RabetMasol_jaygozinMiblie().setValue("")
    this.get_Form_RabetMasol_majaziMobile().setValue("")
  }

  //#endregion


  //#region Validity period

  Data_List_Expiration:Array<FeildActivity_Interface>=[]
  Read_Expiration(){
    this.Expiration_Service.GetActive(this.Token).subscribe(
      data=>{
        this.Data_List_Expiration=data
        this.ReadData_MailMessage()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



  Find_Expiration_Title(id)
  {
    for(let item of this.Data_List_Expiration)
    {
      if(item.id==id)
      {
        return item.title
      }
    }
    return ''
  }

  //#endregion


  //#region MailMessage
  MailMessageForm: FormGroup
  DataList_MailMessage: Array<MailMessage_Interface> = []
  FormAdded_MailMessage: Array<General_Interface> = []

  ReadData_MailMessage() {
    this.MailMessage_Service.GetRecord(this.Token, 3).subscribe(
      data => {
        this.DataList_MailMessage = data
      }
    )
  }

  get_MailMessageForm_mailmessage_id() {
    return this.MailMessageForm.get('mailmessage_id') as FormControl;
  }

  MailMessageForm_Delete(id) {
    this.FormAdded_MailMessage.splice(id, 1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
  }

  MailMessageForm_Submit() {
    if (this.get_MailMessageForm_mailmessage_id().value == "0") {
      this.Alerify.ErrorMessage("Select a letter message.")
    }
    else {
      var Chekcer: boolean = false
      for (let detail of this.FormAdded_MailMessage) {
        if (detail.id == Number(this.get_MailMessageForm_mailmessage_id().value)) {
          Chekcer = true
          break
        }
      }

      if (Chekcer) {
        this.Alerify.ErrorMessage("The selected letter message already exists in the list.")
      }
      else {
        var temp: General_Interface = Empty_General_Interface()
        temp.id = Number(this.get_MailMessageForm_mailmessage_id().value)
        temp.title = this.Find_MailMessage(temp.id)
        this.FormAdded_MailMessage.push(temp)
        this.Alerify.SuccessMessage('Information saved successfully.')
      }
    }

  }

  Find_MailMessage(id: number) {
    for (let item of this.DataList_MailMessage) {
      if (id == item.id) {
        return item.title
      }
    }
  }

  //#endregion


  //#region Instrument

  modalRef_Device: any;

  ProcssingDevice:boolean=false
  Calibration_Device_Parent:number=0
  Search_Name_Device_Table:string=''


  openModal_Device(template: TemplateRef<any>,parent:number) {
    this.modalRef_Device = this.modalService.show(template);
    this.Calibration_Device_Parent=parent
  }

  DataList_Device:Array<LetterRequestCustomer_Device_Interface>=[]
  DataList_Device_Filtered:Array<LetterRequestCustomer_Device_Interface>=[]
  Data_Seleted_Record_LetterRequestCustomer_Device:LetterRequestCustomer_Device_Interface=Empty_LetterRequestCustomer_Device_Interface()


  ReadData_Device_KeySearch_Timer:any
  ReadData_Device_KeySearch(){

    if (this.ReadData_Device_KeySearch_Timer) {
      clearTimeout(this.ReadData_Device_KeySearch_Timer);
      this.ReadData_Device_KeySearch_Timer = null;
  }

  this.ReadData_Device_KeySearch_Timer = setTimeout(function (){
    this.ReadData_Device()
  }.bind(this), 1000);

  }

  ReadData_Device(){
    this.ProcssingDevice=true
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerDeviceListDetail(
      this.Selected_DataList_LetterRequestCustomer.id,
      0,
      1,
      this.Token).subscribe(
      data=>{
        this.DataList_Device=data
        this.ProcssingDevice=false
        this.Filter_Selected_Device()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  Filter_Selected_Device(){

    this.DataList_Device_Filtered=[]
    for(let item of this.DataList_Device)
    {
      if(this.Check_Is_Exist__LetterRequestCustomer_Device_Interface(item.id)==false)
      {
        this.DataList_Device_Filtered.push(item)
      }
    }

  }


  Selected_LetterRequestCustomer_Device_Interface:Array<Number>=[]
  Set_Selected_Device_Record(item:LetterRequestCustomer_Device_Interface){
    this.Data_Seleted_Record_LetterRequestCustomer_Device=item
    //this.modalRef_Device.hide()

    if(this.Check_Is_Exist__LetterRequestCustomer_Device_Interface(item.id))
    {
      this.Alerify.ErrorMessage("The instrument already exists in the list.")
    }
    else{


      this.Selected_LetterRequestCustomer_Device_Interface.push(item.id)
      var temp={
        id:0,
        device_id:Number(this.Data_Seleted_Record_LetterRequestCustomer_Device.device_id),
        device_name:this.Data_Seleted_Record_LetterRequestCustomer_Device.device_name_en,
        kala_code:"",
        device_code:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceCode+'',
        device_serial:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceSerial+'',
        expiration:Number(item.expiration),
        expiration_title:'',
        dsc:this.Data_Seleted_Record_LetterRequestCustomer_Device.deviceCustomerDsc+'',
        asteghrar:this.DefaultAsteghrarValue,
        priority:item.id,
        parent:this.Calibration_Device_Parent,
        priority_title:'',
        priod:0,
        persianDate: '',

        expert_off: 0,
        status: 1,
        canEditDetail:0,

        tEMPERATURE_MIN:0,
        tEMPERATURE_MAX:0,
        tEMPERATURE_Vahed_id:0,
        tEMPERATURE_Vahed_Title:'',

        rELATIVE_HUMIDITY_MIN:0,
        rELATIVE_HUMIDITY_MAX:0,
        rELATIVE_HUMIDITY_Vahed_id:0,
        rELATIVE_HUMIDITY_Vahed_Title:'',

        aTMOSPHERIC_PRESSURE_MIN:0,
        aTMOSPHERIC_PRESSURE_MAX:0,
        aTMOSPHERIC_PRESSURE_Vahed_id:0,
        aTMOSPHERIC_PRESSURE_Vahed_Title:'',
        labAdderss:'',
        visible:true,
        showDeviceBehfa:false,

        manufactureData:[],
        deviceBehfa:[],
        child:[],
        display_linearity:0,
      }

      if(this.Calibration_Device_Parent==-1)
        this.Data_List_Calibration.push(temp)
      else{
        this.Data_List_Calibration[this.Calibration_Device_Parent].child.push(temp)
      }

      this.Alerify.SuccessMessage("The instrument was added to the list.")
      this.Filter_Selected_Device()
    }

  }

  DefaultAsteghrarValue=''
  setAsteghrar(item:Calibration_Interface){
    this.DefaultAsteghrarValue=item.asteghrar
  }

  Check_Is_Exist__LetterRequestCustomer_Device_Interface(id:Number)
  {
    for(let item of this.Selected_LetterRequestCustomer_Device_Interface)
    {
      if(item == id)
      {
        return true
      }
    }
    return false
  }

  //#endregion


  //#region Instrument table


  Data_List_Calibration:Array<Calibration_Interface>=[]


  Delete_List_Calibration(id){
    var temp = this.Data_List_Calibration[id]
    this.Data_List_Calibration.splice(id,1)

    
    
    this.Selected_LetterRequestCustomer_Device_Interface.splice(this.Selected_LetterRequestCustomer_Device_Interface.indexOf(temp.priority),1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
    this.Filter_Selected_Device()
  }

  Delete_List_CalibrationChild(id,parent){
    var temp = this.Data_List_Calibration[parent].child[id]
    this.Data_List_Calibration[parent].child.splice(id,1)

    
    
    this.Selected_LetterRequestCustomer_Device_Interface.splice(this.Selected_LetterRequestCustomer_Device_Interface.indexOf(temp.priority),1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
    this.Filter_Selected_Device()
  }


  Visible_List_Calibration(item:Calibration_Interface){

    this.Calibration_Service.SetCalibrationDetailVisible(this.Token,item.id).subscribe(
      data=>{
        item.visible=!item.visible
        this.Alerify.SuccessMessage("Changes applied successfully.")
      }
    )
  }


  //#endregion



  //#region LetterRequestCustomer


  Procssing_LetterRequestCustomer:boolean=false
  Search_persianDate_LetterRequestCustomer:String=''
  Search_customer_LetterRequestCustomer:String=''
  Search_code_LetterRequestCustomer:String=''



  Show_Draft_LetterRequestCustomer:string='0'
  Selected_DataList_LetterRequestCustomer:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()
  Selected_DataList_LetterRequestCustomerDraft:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()
  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  ReadData_LetterRequestCustomer(){
    this.Procssing_LetterRequestCustomer=true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerCalibration_Reception(this.Token,false,this.Show_Draft_LetterRequestCustomer=='1').subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data
        this.Procssing_LetterRequestCustomer=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )

  }

  Set_Selected_LetterRequestCustomer(item:LetterRequestCustomer_List_Interface){
    this.Selected_DataList_LetterRequestCustomer=item
    this.Data_Seleted_Customer.id=Number(this.Selected_DataList_LetterRequestCustomer.customerId)
    this.Data_Seleted_Customer.name=this.Selected_DataList_LetterRequestCustomer.customer+''

    this.Selected_LetterRequestCustomer_Device_Interface=[]
    this.Data_List_Calibration=[]


    this.Read_Recipt_Letter_Info()
  }


  DraftClibrationReceptionDsc:string=''
  ChangeDraftClibrationReception(item:LetterRequestCustomer_List_Interface){
    this.Procssing_LetterRequestCustomer=true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.ChangeDraftClibrationReception(this.Token,item.id,'',false).subscribe(
      data=>{
        this.Alerify.SuccessMessage("Information saved successfully.")
        this.ReadData_LetterRequestCustomer()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }
  ChangeDraftClibrationReceptionModal(){
    this.Procssing_LetterRequestCustomer=true
    this.DataList_LetterRequestCustomer=[]
    this.LetterRequestCustomer_Service.ChangeDraftClibrationReception(
      this.Token,
      this.Selected_DataList_LetterRequestCustomerDraft.id,
      this.DraftClibrationReceptionDsc,
      false).subscribe(
      data=>{
        this.Alerify.SuccessMessage("Information saved successfully.")
        this.DraftClibrationReceptionDsc=''
        this.modalRef_DraftClibrationReception.hide()
        this.ReadData_LetterRequestCustomer()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  modalRef_DraftClibrationReception:any
  openModal_DraftClibrationReception(template: TemplateRef<any>,item:LetterRequestCustomer_List_Interface) {
    this.modalRef_DraftClibrationReception = this.modalService.show(template);
    this.DraftClibrationReceptionDsc=''
    this.Selected_DataList_LetterRequestCustomerDraft=item
  }


  //#endregion



  //#region Behfa equipment
  modalRef_DeviceBefa: any;
  Filter_Behfa_Item:string=''
  DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_Calibration_Record:Calibration_Interface=Empty_Calibration_Interface()
  //Selected_DataList_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  Selected_DataList_DeviceBehfa_Record:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  Procssing_DeviceBehfa:boolean=false
  ReadData_DeviceBehfa(){
    this.Procssing_DeviceBehfa=true
    this.DeviceBehfa_Service.GetRecordCalibrationReception(this.Token).subscribe(
      data=>{
        this.DataList_DeviceBehfa=data
        this.Procssing_DeviceBehfa=false

      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal_DeviceBefa(template: TemplateRef<any>,item:Calibration_Interface) {
    this.modalRef_DeviceBefa = this.modalService.show(template);
    this.Selected_Calibration_Record = item
    this.DataList_Device_Filtered=[]
  }

  Set_Selected_DeviceBefa_Record(item){
    this.Selected_DataList_DeviceBehfa_Record=item
    this.modalRef_DeviceBefa.hide()
    this.AddTo_DeviceBefa_List()
  }

  Delete_List_DeviceBehfa(id:number,item:Calibration_Interface){
    item.deviceBehfa.splice(id,1)
    this.Alerify.SuccessMessage(" Deleted successfully.")
  }


  AddTo_DeviceBefa_List(){

    var CheckExisted:boolean=false

    for(let item of this.Selected_Calibration_Record.deviceBehfa)
    {
      if(item.id_temp==this.Selected_DataList_DeviceBehfa_Record.id_temp)
      {
        CheckExisted=true
        break
      }
    }

    if(this.Selected_DataList_DeviceBehfa_Record.id_temp==0)
    {
      this.Alerify.ErrorMessage(" No instrument has been selected.")
    }
    else if(CheckExisted)
    {
      this.Alerify.ErrorMessage("This instrument already exists in the list.")
    }
    else{
      this.Selected_Calibration_Record.deviceBehfa.push(this.Selected_DataList_DeviceBehfa_Record)
      this.Selected_DataList_DeviceBehfa_Record=Empty_DeviceBehfa_Interface()
      this.Alerify.SuccessMessage("Added to the list.")
    }
  }

  //#endregion


  //#region Visible Karshnas

  Change_Visible_Karshnas() {
    this.Calibration_Service.VisibleKarshnasPrint(this.Calibration_Form_Id, this.Token).subscribe(
      data => {
        this.visible_karshnas=!this.visible_karshnas
        this.Alerify.SuccessMessage("Applied successfully.")
      }
    )
  }

  //#endregion


  order:string=''
  orderreverse :boolean=true

  ChangeOrder(item:string)
  {
    this.order=item
    this.orderreverse=!this.orderreverse
  }



  modalRef_Code: any;
  modalRef_FinishForm:any;

  openModal_FinishForm(template: TemplateRef<any>) {
    var Check_Record_Data_List_Calibration:number=-1;
    var Check_Record_Data_List_Calibration_Status:boolean=false;
    for(let item of this.Data_List_Calibration)
    {
      Check_Record_Data_List_Calibration=Check_Record_Data_List_Calibration+1
      if(item.device_code=='' && item.device_serial=='')
      {
        Check_Record_Data_List_Calibration_Status=true
        break;
      }
    }

    if(Check_Record_Data_List_Calibration_Status)
      this.Alerify.ErrorMessage("Enter the instrument code or serial number in row "+(Check_Record_Data_List_Calibration+1)+".")
    else
      this.modalRef_FinishForm = this.modalService.show(template);
  }

  OnSubmitForm_Finish:boolean=false
  Proccesing_SubmitForm:boolean=false
  OnSubmitForm(id:number,template: TemplateRef<any>)
  {
    if(this.modalRef_FinishForm)
      this.modalRef_FinishForm.hide()

    this.Proccesing_SubmitForm=true

    this.Calibration_Service.AddEditCalibration(
        this.Data_List_Calibration,
        [],
        [],
        [],
        //this.Selected_LetterRequestCustomer_Device_Interface,
        this.Selected_DataList_LetterRequestCustomer.id,
        0,
        this.Data_Seleted_Customer.id,
        this.Data_Seleted_ReciveCustomer.id,
        this.Calibration_Form_Id,
        false,
        this.Data_Seleted_ReciveCustomer_Dsc,
        this.Calibration_Form_Dsc,
        id == 1,
        '',
        this.Calibration_Form_TahvilDahandeh,
        this.FormAdded_MailMessage,
        this.Token).subscribe(data=>{
        if(data['id']==-1)
        {
          this.Alerify.ErrorMessage(data['code']);
          this.Proccesing_SubmitForm=false
        }
        else{
          //this.OnSubmitForm_Finish=(true)
          this.Proccesing_SubmitForm=false
          this.Calibration_Form_Code=data['code']
          this.Calibration_Form_Id = data['id']
          this.OnInitail_Form(this.Calibration_Form_Id);
          this.modalRef_Code = this.modalService.show(template);
        }
        },error=>{
          localStorage.clear()
          location.reload();

        })
  }


  OnSet_Back_CalibrationList(){
    this.OnBack_Calibration_Action.emit(-1);
    localStorage.removeItem('Daro_User_Comment')
  }








}
